import React, { useState } from "react";
import { connect } from "react-redux";
import { CButton } from "@appcues/component-library";
import styled from "styled-components";
import { requestSpoof, cancelSpoof } from "actions/spoofing";
import Input from "components/Common/Forms/Input";

const StyledSpoofingControl = styled.div`
  width: 220px;
  position: fixed;
  top: 0;
  left: 10px;
  height: 35px;
  display: flex;
  justify-content: center;
  z-index: 10000;
  .button {
    font-size: 0.9em;
    padding: 4px;
    border-radius: 0;
    margin-left: -1px;
  }
  input {
    border: 2px solid ${props => props.theme["$dark-tint-10"]};
    border-radius: 0;
    max-width: 90px;
  }
  & > form {
    display: flex;
    border-radius: 4px;
  }
`;

const StyledSpoofingBanner = styled.div`
  width: 220px;
  z-index: 1000;
  background: ${props => props.theme["$red"]};
  position: fixed;
  top: 0;
  left: 0;
  padding: 6px 0;
  color: white;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 11px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
    box-shadow: ${props => props.theme["$box-shadow-2"]};
  }

  em {
    font-weight: 300;
    opacity: 0.7;
    margin-left: 3px;
    text-transform: none;
  }
`;

export function SpoofingControl({ accountId, onSubmit, onCancel }) {
  const [value, setValue] = useState("");

  const handleChange = e => setValue(e.target.value);
  const handleSubmit = e => {
    e.preventDefault();
    onSubmit(value);
  };

  if (accountId) {
    return (
      <StyledSpoofingBanner onClick={onCancel}>
        Spoofing {accountId} <em>(Click to Cancel)</em>
      </StyledSpoofingBanner>
    );
  }
  return (
    <StyledSpoofingControl>
      <form onSubmit={handleSubmit}>
        <Input placeholder="Account ID" value={value} onChange={handleChange} />
        <CButton onClick={handleSubmit} type="info" className="button">
          Spoof
        </CButton>
      </form>
    </StyledSpoofingControl>
  );
}

const mapStateToProps = state => ({
  accountId: state.spoofing,
  // setting the key forces a new useState value, i guess?
  key: state.spoofing
});

const mapDispatchToProps = {
  onSubmit: requestSpoof,
  onCancel: cancelSpoof
};

export default connect(mapStateToProps, mapDispatchToProps)(SpoofingControl);
